import createModule from "../createModule"
import view from "./view"
import { Creators } from "./model"
import { Creators as ProfileCreators } from "model/profileModal"
import { Creators as PortfolioRootCreators } from "modules/portfolio-root/model"
import { getDetails, getSelected, getSelectedValue } from "./selectors"
import { getFiltersVisible } from "modules/analyze-header/selectors"

export default createModule({
  view,
  mapStateToProps: (state, props) => ({
    ...state.modules.analyzeBetaDetails,
    details: getDetails(state, props),
    selected: getSelected(state, props),
    selectedValue: getSelectedValue(state, props),
    filtersVisible: getFiltersVisible(state, props),
  }),
  actions: {
    ...Creators,
    openSecurityProfile: ProfileCreators.openSecurityProfile,
    openFactorProfile: ProfileCreators.openFactorProfile,
    toggleShowNotHeld: PortfolioRootCreators.toggleShowNotHeld,
  },
})
